"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Image;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRainbowComponents = require("react-rainbow-components");

var _icons = require("@rainbow-modules/icons");

var _app = require("@rainbow-modules/app");

var _RenderIf = _interopRequireDefault(require("react-rainbow-components/components/RenderIf"));

var _truncatedText = _interopRequireDefault(require("react-rainbow-components/components/Structural/truncatedText"));

var _styled = require("./styled");

function Image(props) {
  var imageRef = props.imageRef,
      onSelect = props.onSelect,
      onError = props.onError,
      allowDelete = props.allowDelete,
      onDelete = props.onDelete;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      src = _useState2[0],
      setSrc = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var deleteBtn = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return imageRef.getDownloadURL().then(function (url) {
                setSrc(url);
              })["catch"](function (error) {
                onError(error);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [imageRef, onError]);

  var handleClick = function handleClick(e) {
    var isDeleteButtonClicked = deleteBtn.current.htmlElementRef.current.contains(e.target);

    if (isDeleteButtonClicked) {
      return null;
    }

    return onSelect(imageRef);
  };

  var openModalDelete = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var result;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _app.confirmModal)({
                icon: /*#__PURE__*/_react["default"].createElement(_styled.TrashIcon, null),
                variant: 'destructive',
                header: 'Are you sure you want to delete this item?',
                question: "This item will be deleted immediately. You can't undo this action.",
                okButtonLabel: 'Delete'
              });

            case 2:
              result = _context2.sent;

              if (result) {
                onDelete(imageRef);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function openModalDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_styled.StyledFileContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.StyledContainerImage, {
    type: "button",
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: !!src
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledImage, {
    src: src,
    alt: imageRef.name,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    $loading: loading
  }), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: allowDelete
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledDeleteButton, {
    variant: "inverse",
    size: "medium",
    icon: /*#__PURE__*/_react["default"].createElement(_icons.Trash, null),
    onClick: openModalDelete,
    ref: deleteBtn
  })), /*#__PURE__*/_react["default"].createElement(_styled.StyledCheckMark, null)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: loading
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledContainerSpinner, null, /*#__PURE__*/_react["default"].createElement(_reactRainbowComponents.Spinner, {
    type: "arc",
    variant: "brand"
  })))), /*#__PURE__*/_react["default"].createElement(_truncatedText["default"], null, imageRef.name));
}

Image.propTypes = {
  imageRef: _propTypes["default"].object.isRequired,
  onSelect: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  allowDelete: _propTypes["default"].bool
};
Image.defaultProps = {
  onSelect: function onSelect() {},
  onError: function onError() {},
  onDelete: function onDelete() {},
  allowDelete: false
};